import { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { useStore } from "@/context/Store";
import { apiError, http, uid, withKeys } from "@/lib/api";

export default function AdminCategories() {
  const { categories, reload } = useStore();
  const [cats, setCats] = useState([]);
  useEffect(() => { setCats(withKeys(categories).map((c) => ({ ...c, subcategories: withKeys(c.subcategories) }))); }, [categories]);
  const upd = (i, k, v) => setCats(cats.map((c, j) => (j === i ? { ...c, [k]: v } : c)));
  const updSub = (i, si, v) => upd(i, "subcategories", cats[i].subcategories.map((s, j) => (j === si ? { ...s, name: v } : s)));
  const save = async () => {
    try { await http.put("/admin/categories", cats); toast.success("Categorias guardadas"); reload(); } catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div data-testid="admin-categories">
      <div className="flex items-center justify-between">
        <h2 className="font-display text-3xl font-bold">Categorias</h2>
        <div className="flex gap-2">
          <button className="btn-ghost" data-testid="admin-add-category" onClick={() => setCats([...cats, { _k: uid(), slug: "", title: "Nova categoria", verb: "", obj: "", what: "", description: "", subcategories: [] }])}><Plus className="h-4 w-4" />Categoria</button>
          <button className="btn-primary" data-testid="admin-save-categories" onClick={save}>Guardar</button>
        </div>
      </div>
      <div className="mt-6 grid gap-5 lg:grid-cols-2">
        {cats.map((c, i) => (
          <div key={c._k} className="space-y-3 rounded-2xl border border-[var(--line)] bg-white p-5" data-testid={`admin-category-${c.slug || i}`}>
            <div className="flex gap-2"><input className="field font-semibold" value={c.title} onChange={(e) => upd(i, "title", e.target.value)} placeholder="Título" data-testid={`admin-category-title-${i}`} />
              <button onClick={() => window.confirm("Remover categoria?") && setCats(cats.filter((_, j) => j !== i))} className="rounded-full p-2 hover:text-red-600"><Trash2 className="h-4 w-4" /></button></div>
            <div className="grid grid-cols-2 gap-2">
              <input className="field" value={c.verb} onChange={(e) => upd(i, "verb", e.target.value)} placeholder="Verbo (ex.: transformam)" />
              <input className="field" value={c.obj} onChange={(e) => upd(i, "obj", e.target.value)} placeholder="Destaque (ex.: a tua casa)" />
            </div>
            <input className="field" value={c.description} onChange={(e) => upd(i, "description", e.target.value)} placeholder="Descrição" />
            <p className="pt-2 text-xs font-semibold text-[var(--muted-ink)]">Subcategorias</p>
            {c.subcategories.map((s, si) => (
              <div key={s._k} className="flex gap-2"><input className="field !py-2" value={s.name} onChange={(e) => updSub(i, si, e.target.value)} data-testid={`admin-sub-${i}-${si}`} />
                <button onClick={() => upd(i, "subcategories", c.subcategories.filter((_, j) => j !== si))} className="p-2 hover:text-red-600"><Trash2 className="h-4 w-4" /></button></div>
            ))}
            <button className="text-sm font-semibold text-[var(--violet)]" data-testid={`admin-add-sub-${i}`} onClick={() => upd(i, "subcategories", [...c.subcategories, { _k: uid(), slug: "", name: "Nova subcategoria" }])}>+ Subcategoria</button>
          </div>
        ))}
      </div>
    </div>
  );
}
